// Global packages and components
import { clsx } from 'clsx'
import {
  AdjustmentsHorizontalIcon,
  ArrowsUpDownIcon,
} from '@heroicons/react/24/outline'

// Types
interface Props {
  isFiltered: boolean
  setOffcanvasSortOpen: (e: boolean) => void
  setOffcanvasFiltersOpen: (e: boolean) => void
  clearAll: () => void
}

// Main export
const ProductControlMobile = ({
  isFiltered,
  setOffcanvasSortOpen,
  setOffcanvasFiltersOpen,
  clearAll,
}: Props) => {
  return (
    <div className="lg:hidden">
      <div
        className={clsx('flex justify-between gap-3', {
          'mb-4': isFiltered,
        })}
      >
        <button
          className="flex w-full items-center justify-center gap-3 rounded-xl bg-neutral-150 px-3 py-3 font-medium"
          onClick={() => setOffcanvasSortOpen(true)}
        >
          <ArrowsUpDownIcon className="size-5" />
          Sort By
        </button>
        <button
          className="flex w-full items-center justify-center gap-3 rounded-xl bg-neutral-150 px-3 py-3 font-medium"
          onClick={() => setOffcanvasFiltersOpen(true)}
        >
          <AdjustmentsHorizontalIcon className="size-5" />
          Filter
        </button>
      </div>
      {isFiltered && (
        <div className="text-center">
          <button
            onClick={clearAll}
            className="font-semibold text-teal-green underline"
          >
            Clear filters
          </button>
        </div>
      )}
    </div>
  )
}

export default ProductControlMobile
